import Color from "color";
import React from "react";
import cardStyles from "./cardStyles";
import { createUseStyles } from "react-jss";
import { mergeDeepRight } from "ramda";

const MAX_TITLE_LINES = 3;
const MAX_TEXT_LINES = 7;
const TEXT_LINE_HEIGHT = 17;
const TEXT_MAX_HEIGHT = TEXT_LINE_HEIGHT * MAX_TEXT_LINES;

const DEFAULT_ICON =
  "M3.32773 3.3H6.10084C6.10084 2.42479 6.45144 1.58542 7.07551 0.966548C7.69958 0.347678 8.546 0 9.42857 0C10.3111 0 11.1576 0.347678 11.7816 0.966548C12.4057 1.58542 12.7563 2.42479 12.7563 3.3H15.5294C16.412 3.3 17.2584 3.64768 17.8825 4.26655C18.5065 4.88542 18.8571 5.72479 18.8571 6.6V18.7C18.8571 19.5752 18.5065 20.4146 17.8825 21.0335C17.2584 21.6523 16.412 22 15.5294 22H3.32773C2.44516 22 1.59874 21.6523 0.97467 21.0335C0.350599 20.4146 0 19.5752 0 18.7V6.6C0 5.72479 0.350599 4.88542 0.97467 4.26655C1.59874 3.64768 2.44516 3.3 3.32773 3.3ZM3.32773 4.4C2.73935 4.4 2.17507 4.63178 1.75902 5.04436C1.34298 5.45694 1.10924 6.01652 1.10924 6.6V18.7C1.10924 19.2835 1.34298 19.8431 1.75902 20.2556C2.17507 20.6682 2.73935 20.9 3.32773 20.9H15.5294C16.1178 20.9 16.6821 20.6682 17.0981 20.2556C17.5142 19.8431 17.7479 19.2835 17.7479 18.7V6.6C17.7479 6.01652 17.5142 5.45694 17.0981 5.04436C16.6821 4.63178 16.1178 4.4 15.5294 4.4H14.4202V7.7H4.43698V4.4H3.32773ZM5.54622 6.6H13.3109V4.4H5.54622V6.6ZM9.42857 1.1C8.84019 1.1 8.27591 1.33178 7.85986 1.74436C7.44382 2.15694 7.21008 2.71652 7.21008 3.3H11.6471C11.6471 2.71652 11.4133 2.15694 10.9973 1.74436C10.5812 1.33178 10.017 1.1 9.42857 1.1ZM3.32773 9.9H15.5294V11H3.32773V9.9ZM3.32773 13.2H15.5294V14.3H3.32773V13.2ZM3.32773 16.5H13.3109V17.6H3.32773V16.5Z";

const useStyles = createUseStyles((theme) =>
  mergeDeepRight(cardStyles, {
    contentWrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "start",
    },
    multilineEllipsis: {
      display: "-webkit-box",
      "-webkit-box-orient": "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    icon: {
      margin: "10px 0 10px 0",
      width: "22px",
      height: "22px",
      border: "0",
    },
    iconPath: { fill: theme.secondaryColor },
    badgesRow: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      flexWrap: "wrap",
      marginBottom: "5px",
    },
    headerBadgeWrapper: {
      height: "21px",
      maxWidth: "100%",
      margin: "0 5px 5px 0",
      padding: "0 5px 0 5px",
      border: "0",
      borderRadius: "2px",
      color: theme.secondaryColor,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: Color(theme.secondaryColor).alpha(0.1).string(),
    },
    headerBadgeText: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      fontSize: "13px",
      lineHeight: "16px",
    },
    title: {
      composes: "$multilineEllipsis",
      "-webkit-line-clamp": `${MAX_TITLE_LINES}`,
      color: theme.cardTextColor,
      fontStyle: "normal",
      fontSize: "17px",
      fontWeight: "500",
      lineHeight: "19px",
      marginBottom: "10px",
      cursor: "pointer",
    },
    text: {
      composes: "$multilineEllipsis",
      "-webkit-line-clamp": `${MAX_TEXT_LINES}`,
      maxHeight: `${TEXT_MAX_HEIGHT}px`,
      lineHeight: `${TEXT_LINE_HEIGHT}px`,
      color: theme.cardTextColorSecondary,
      fontSize: "13px",
    },
  })
);

export default ({ result }) => {
  const styles = useStyles();
  return (
    <div>
      <div className={styles.contentWrapper}>
        <div className={styles.icon}>
          <svg fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              className={styles.iconPath}
              // TODO(nur): Ugly hack until cards are generalized.
              d={result.imageUrl || DEFAULT_ICON}
            />
          </svg>
        </div>
        {result.headers && (
          <div className={styles.badgesRow}>
            {result.headers.map((badgeText, i) => (
              <div className={styles.headerBadgeWrapper} key={i}>
                <div className={styles.headerBadgeText}>{badgeText}</div>
              </div>
            ))}
          </div>
        )}
        <div className={styles.title}>{result.title}</div>
        <div className={styles.text}>{result.text}</div>
      </div>
    </div>
  );
};
